import { useEffect, useRef, useState } from "react";
import { NotificationManager } from "react-notifications";
import { CreacionPaletizacionApi } from "../api/CreacionPaletizacionApi";
import { getErrorFromResponse } from "../../../../../../../../../utility/utils";
import { useDebounce } from "../../../../../../../Utils/Hooks/useDebounce";

// Números de pallets rechazados por bodega que se pueden volver a usar. El
// listado se consulta cada vez que se abre el modal, porque otro pallet pudo
// haberse llevado el número mientras tanto
export const useNumeroPallet = ({
    opened,
    onClose,
    palletRechazado,
    setPalletRechazado,
}) => {
    const { getPalletsRechazadosReutilizables, cargando } =
        CreacionPaletizacionApi();

    const [palletsRechazados, setPalletsRechazados] = useState([]);
    const [cantidadResultados, setCantidadResultados] = useState(0);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(1);
    const [search, setSearch] = useState("");

    const searchDebounced = useDebounce(search, 500);

    // solo se atiende la última búsqueda pedida, para que una respuesta lenta
    // no pise el resultado de una más nueva
    const ultimaPeticion = useRef(0);

    const GetPalletsRechazados = async () => {
        const peticion = ultimaPeticion.current + 1;
        ultimaPeticion.current = peticion;

        try {
            const params = { page: paginaSeleccionada };

            if (searchDebounced) params.search = searchDebounced;

            const response = await getPalletsRechazadosReutilizables(params);

            if (peticion !== ultimaPeticion.current) return;

            setPalletsRechazados(response.results || []);
            setCantidadResultados(response.count || 0);
        } catch (error) {
            if (peticion !== ultimaPeticion.current) return;

            // si la página dejó de existir, volvemos a la anterior
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada((prev) => prev - 1);
                return;
            }

            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener los números de pallet rechazados",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setPalletsRechazados([]);
            setCantidadResultados(0);
        }
    };

    useEffect(() => {
        if (!opened) return;

        GetPalletsRechazados();
    }, [opened, paginaSeleccionada, searchDebounced]);

    // al cerrar se descarta la búsqueda, para que la siguiente vez abra con el
    // listado completo
    useEffect(() => {
        if (opened) return;

        setSearch("");
        setPaginaSeleccionada(1);
    }, [opened]);

    const handleSearch = (valor) => {
        setSearch(valor);
        setPaginaSeleccionada(1);
    };

    const handleSeleccionar = (pallet) => {
        setPalletRechazado(pallet);
        onClose();
    };

    const handleNumeroNuevo = () => {
        setPalletRechazado(null);
        onClose();
    };

    return {
        palletsRechazados,
        cantidadResultados,
        paginaSeleccionada,
        setPaginaSeleccionada,

        search,
        handleSearch,

        palletRechazado,
        handleSeleccionar,
        handleNumeroNuevo,

        cargando,
    };
};
